// extracted by mini-css-extract-plugin
export default {"theme_modal":"ForgotPasswordModal_theme_modal__RSDjH","profile_img":"ForgotPasswordModal_profile_img__zkFtL","member_designation":"ForgotPasswordModal_member_designation__qyTsQ"};